module.exports = __webpack_public_path__ + "static/media/KEITH MONKS REDUX 2 DISCOVERY ONE.9ba9244a.png";